 

//fund details page
import actions from './modules/actions';
import allClassifications from './modules/all-classifications/state';
import allStrategies from './modules/allStrategies';
import audiences from '_shared_/utils/user-audience';
import assetMixChart from './modules/asset-mix/state';
import averageLife from './modules/averageLife/state';
import bondBreakdown from './modules/bond-breakdown/state';
import capitalization from './modules/capitalization-distribution/state';
import chartData from './modals/chart-data/state';
import clientContent from './modules/client-content/state';
import context from './modules/context/state';
import description from './modules/description/state';
import durationExposure from './modules/durationExposure/state';
import equitiesBreakdown from './modules/equities-breakdown/state';
import fundAttributes from './fund-attributes/state';
import fundFacts from './modules/fund-facts/state';
import fundStatistics from './modules/fund-statistics/state';
import fundInfoData from './modules/fund-info/state';
import geographicBreakdown from './modules/geographic-breakdown/state';
import geographicDiversities from './modules/geographic-diversification/state';
import geographyInvesting from './modules/geography-investing/state';
import growth10k from './modules/growth-10k/state';
import keyStatistics from './modules/key-statistics/state';
import resources from './modules/resources/state';
import morningstarOwnershipZone from './modules/morningtstar-ownership/state';
import morningtstarRatings from './modules/morningstarRatings/state';
import moringstarStyleBox from './modules/mstar-style-box/state';
import portfolioManagement from './modules/portfolio-management/state';
import purchaseRestrictions from './modules/purchase-restrictions/state';
import qualitySummary from './modules/qualitySummary/state';
import quarterlyHoldings from './modules/quarterly-holdings/state';
import returns from './modules/returns/state';
import returnAtNav from './modules/return-at-nav/state';
import riskMeasures from './modules/risk-measures/state';
import sectorExposure from './modules/sector-exposure/state';
import summary from './modules/summary/state';
import summaryFacts from './modules/summary-facts/state';
import volatilityLarge from './modals/volatility-large/state';
import volatilityReturn from './modules/volatility-return/state';
import marketCapitalization from './modules/market-capitalization/state';
import underlyingFunds from './modules/underlying-funds/state';
import fees from './modules/fees/state';
import expenses from './modules/expenses/state';
import historicalPrices from './modules/historical-prices/state';
import historicalDistributionsModule from './modules/historical-distributions/state';
import returnsPage from './pages/returns/state';
import returnsFilters from './returns-page/returns-filters/state';

import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      activeTab: '',
      apiBase: '',
      appConfig: {},
      audience: '',
      breakpoint: {
        isSmall: window.innerWidth <= 480,
        isMedium: window.innerWidth > 480 && window.innerWidth < 769,
        isLarge: window.innerWidth >= 769
      },
      cssLoaded: false,
      disclosureApiBase: '',
      disclosureCollection: {
        products: [],
        statistics: []
      },
      disclosureSuperscripts: {},
      environment: '',
      fundObjective: '',
      IBallCollection: [],
      IBallDescriptions: {},
      isAdvisor: false,
      isAuthorizedAudience(validAudiences, currentAudience) {
        return validAudiences.includes(currentAudience);
      },
      isIndividual: false,
      isInstitutional: false,
      selectedChartTab: '',
      showDetailModal: false,
      showEnvironmentSwitcher: false,
      showJumpModal: false,
      stagingFlag: '',
      symbol: '',
      vehicleId: '',
      windowSize: window.innerWidth
    };
  },
  mutations: {
    changeAccount(state, account) {
      state.account = account;
      state.fundObjective = account.objective.toLowerCase();
    },
    setAppConfig(state, appConfig) {
      state.appConfig = appConfig;

      if (appConfig.context && appConfig.context.userType) {
        state.audience = appConfig.context.userType;
        state.isAdvisor = state.audience === audiences.advisor;
        state.isIndividual = state.audience === audiences.individual;
        state.isInstitutional = state.audience === audiences.institutional;
      }
    },
    changeTab(state, activeTab) {
      state.activeTab = activeTab;
    },
    cssLoaded(state, loaded) {
      state.cssLoaded = loaded;
    },
    displayModal(state, modal) {
      state.showJumpModal = modal.modal === 'jump modal';
      state.showDetailModal = modal.showModal;
      state.selectedChartTab = modal.activeTab;
    },
    init(state, payload) {
      state.apiBase = payload.apiBase;
      state.baseUrl = payload.baseUrl;
      state.disclosureApiBase = payload.disclosureApiBase;
      state.environment = payload.environment;
      state.stagingFlag = payload.stagingFlag;
    },
    setBreakpoint(state, payload) {
      state.breakpoint.isSmall = payload <= 480;
      state.breakpoint.isMedium = payload > 480 && window.innerWidth < 769;
      state.breakpoint.isLarge = payload >= 769;
    },
    updateIBallCollection(state, payload) {
      state.IBallCollection = payload;
    },
    updateDisclosureCollection(state, payload) {
      if (payload) state.disclosureCollection = payload;
       
      console.log('DisclosureCollection: ', JSON.stringify(state.disclosureCollection));
      F2.Events.emit('update_statistic_list', JSON.stringify(state.disclosureCollection));
    },
    updateDisclosureSuperscripts(state, payload) {
      state.disclosureSuperscripts = { ...state.disclosureSuperscripts, ...payload };
    },
    updateShowEnvironmentSwitcher(state, showEnvironmentSwitcher) {
      state.showEnvironmentSwitcher = showEnvironmentSwitcher;
    },
    updateIBallDescriptions(state, payload) {
      state.IBallDescriptions = Object.assign({}, state.IBallDescriptions, payload);
    },
    updateStagingFlag(state, payload) {
      state.stagingFlag = payload;
    }
  },
  getters: {
    activeNavTab: state => state.activeTab,
    appConfig: state => state.appConfig,
    cssLoaded: state => state.cssLoaded,
    disclosureSuperscripts: state => state.disclosureSuperscripts,
    disclosureCollection: state => state.disclosureCollection,
    fundObjective: state => state.fundObjective,
    getApiBase: state => state.apiBase,
    getApplicationName: state => state.appConfig.applicationName,
    getAudience: state => state.audience,
    getBaseUrl: state => state.baseUrl,
    getBreakpoint: state => state.breakpoint,
    getDisclosureApiBase: state => state.disclosureApiBase,
    getEnvironment: state => state.environment,
    IBallCollection: state => state.IBallCollection,
    IBallDescriptions: state => state.IBallDescriptions,
    isInstitutional: state => state.isInstitutional,
    selectedChartTab: state => state.selectedChartTab,
    showDetailModal: state => state.showDetailModal,
    showEnvironmentSwitcher: state => state.showEnvironmentSwitcher,
    showJumpModal: state => state.showJumpModal
  },
  actions,
  modules: {
    allStrategies,
    allClassifications,
    assetMixChart,
    averageLife,
    bondBreakdown,
    capitalization,
    chartData,
    clientContent,
    context,
    description,
    durationExposure,
    equitiesBreakdown,
    fundAttributes,
    fundFacts,
    fundStatistics,
    fundInfoData,
    geographicBreakdown,
    geographicDiversities,
    geographyInvesting,
    growth10k,
    keyStatistics,
    resources,
    morningstarOwnershipZone,
    morningtstarRatings,
    moringstarStyleBox,
    portfolioManagement,
    purchaseRestrictions,
    qualitySummary,
    quarterlyHoldings,
    returns,
    returnAtNav,
    riskMeasures,
    sectorExposure,
    summary,
    summaryFacts,
    volatilityLarge,
    volatilityReturn,
    marketCapitalization,
    fees,
    expenses,
    underlyingFunds,
    historicalPrices,
    historicalDistributionsModule,
    returnsFilters,
    returnsPage
  }
});

export default store;
